import Home from './components/home.vue';
import Features from './components/features.vue';
import Pricing from './components/pricing.vue';
import Contact from './components/contact.vue';
import Toolkit from './components/toolkit.vue';
import Simulator from './components/simulator.vue';
import Privacy from './components/privacy.vue';
import Announcements from './components/announcement.vue';


export const routes = [
  { path: '/', component: Home},
  { path: '/features', component: Features},
  { path: '/pricing', component: Pricing},
  { path: '/contact', component: Contact},
  { path: '/toolkit', component: Toolkit},
  { path: '/simulator', component: Simulator},
  { path: '/privacy', component: Privacy},
  { path: '/announcements', component: Announcements}
]
